import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  contentItem: {
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "100%",
    minHeight: 90,
    borderRadius: 4,
    padding: 10,
    flexDirection: "row",
    marginBottom: 10,
    marginTop: 10,
    flexWrap: "wrap",
    shadowColor: "#000",
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },

  certificateHeaders: {
    textTransform: "uppercase",
    fontSize: 14,
    color: "#077A97",
  },

  columnContainer: {
    maxWidth: 120,
    minWidth: 120,
    flexDirection: "column",
    alignItems: "center",
  },

  ativoImgRowContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },

  dadosAtivo: {
    flexWrap: "wrap",
    fontSize: 16,
    textAlign: "center",
  },

  flagIcon: {
    width: 28,
    height: 21,
  },

  img: {
    width: 26,
    height: 26,
    borderRadius: 20,
    resizeMode: "cover",
  },

  bandeirasBtnContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    alignSelf: "center",
  },

  center: {
    height: "50%",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },

  filterContainer: {
    paddingHorizontal: 10,
    paddingTop: 10,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  inputWrapper: {
    flexGrow: 1,
    flexBasis: "46%",
    minWidth: 180, 
    marginBottom: 10,
  },
  input: {
    height: 40,
    borderColor: "#ccc",
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 10,
    width: "100%",
  },
  paginationContainer: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    padding: 15,
    borderTopWidth: 1,
    borderTopColor: "#eee",
  },
  paginationButton: {
    backgroundColor: "#2797A2",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  disabledButton: {
    backgroundColor: "#ccc",
  },
  paginationText: {
    color: "white",
    fontWeight: "bold",
  },
  paginationInfo: {
    fontWeight: "bold",
    fontSize: 16,
  },
});

export default styles;
